export const LOGGING = {
  PAGE_NAME: 'banana',
  HOUSTON_REDIRECT: 'Redirecting to houston',
};
